import { fetchList } from '@bit/knotchinc.web-react-components.utils.fetch-actions';

import {
  keywords,
  categories,
  content,
  hubs,
} from 'api';

import {
  FETCH_CATEGORIES_LIST, FETCHED_CATEGORIES_LIST,
  FETCH_KEYWORDS_LIST, FETCHED_KEYWORDS_LIST,
  FETCH_HUBS_LIST, FETCHED_HUBS_LIST,
 } from 'components/Global/Filters/actions.js';

export const FETCH_HUB_CONTENT = 'FETCH_HUB_CONTENT';
export const FETCHED_HUB_CONTENT = 'FETCHED_HUB_CONTENT';
export const SET_HUB_CONTENT_FILTER = 'SET_HUB_CONTENT_FILTER';

export const fetchBrandHubs = (clear, entityId) => (dispatch, getState) =>
  fetchList({
    clear,
    dispatch,
    getState,
    store: getState().HubsList.hubsList,
    fetchingActionType: FETCH_HUBS_LIST,
    fetchedActionType: FETCHED_HUBS_LIST,
    apiCall: (filters) => hubs.getBrandHubs(entityId, filters),
  });

export const fetchHubsContent = (clear, brandId, hubId) => (dispatch, getState) => fetchList({
  clear,
  dispatch,
  getState,
  store: getState().HubProfile.hubContentList,
  fetchingActionType: FETCH_HUB_CONTENT,
  fetchedActionType: FETCHED_HUB_CONTENT,
  apiCall: (filters) => content.getHubsContent(brandId, hubId, filters),
});

export const fetchHubsKeywords = (clear, entityId, hubId) => (dispatch, getState) => fetchList({
  clear,
  dispatch,
  store: getState().KeywordsList.keywordsList,
  fetchingActionType: FETCH_KEYWORDS_LIST,
  fetchedActionType: FETCHED_KEYWORDS_LIST,
  apiCall: filters => keywords.getHubsKeywords(entityId, hubId, filters),
});

export const fetchHubsCategories = (clear, entityId, hubId) => (dispatch, getState) =>
  fetchList({
    clear,
    dispatch,
    getState,
    store: getState().CategoriesList.categoriesList,
    fetchingActionType: FETCH_CATEGORIES_LIST,
    fetchedActionType: FETCHED_CATEGORIES_LIST,
    apiCall: filters => categories.getHubsCategories(entityId, hubId, filters),
  });
